import { useState, useEffect } from "react";
import Toggle from "react-toggle";
import Box from "../Box";
import AlertBox from "../AlertBox";
import { updateDisruptionArea } from "../../api/setting";
import { useDisruptionAreaHooks } from "../../utils/SettingUtils";
import { useControlPermission } from "../../utils/ActionPermissionUtils";

export default function BoxInternetDistruptionArea() {
  let { hasAccess } = useControlPermission();

  let { data, fetched, loading: dataLoading, getDisruptionAreaSetting } = useDisruptionAreaHooks();
  let [alert, setAlert] = useState({ show: false, message: "", type: "" });
  let [info, setInfo] = useState({
    disruption_message: "",
    not_found_message: "",
    no_disruption_message: "",
  });
  let [areas, setAreas] = useState([]);
  let [newArea, setNewArea] = useState("");
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    if (fetched) {
      setInfo({
        disruption_message: data.info?.disruption_message || "",
        not_found_message: data.info?.not_found_message || "",
        no_disruption_message: data.info?.no_disruption_message || "",
      });
      setAreas(data.areas || []);
    }
  }, [fetched, data]);

  const getErrorMessage = (error) => {
    if (error.response) {
      let { data } = error.response;
      return data.message;
    }
    return "Something Error Happened";
  };

  const submitData = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      let response = await updateDisruptionArea({ info, areas });
      setAlert({ show: true, message: response.data.message, type: "success" });
      getDisruptionAreaSetting();
    } catch (error) {
      setAlert({ show: true, message: getErrorMessage(error), type: "danger" });
    }
    setLoading(false);
  };

  const changeInfoValue = (key, value) => {
    setInfo({ ...info, [key]: value });
  };

  const changeAreaStatus = (index, checked) => {
    let tempAreas = [...areas];
    tempAreas[index] = { ...tempAreas[index], status: checked ? "on" : "off" };
    setAreas(tempAreas);
  };

  const addArea = () => {
    let name = newArea.trim();
    if (!name) return;
    if (areas.some((area) => area.name === name)) {
      setAlert({ show: true, message: `Daerah ${name} sudah ada`, type: "danger" });
      return;
    }
    setAreas([...areas, { name, status: "off" }]);
    setNewArea("");
  };

  const deleteArea = (index) => {
    let tempAreas = [...areas];
    tempAreas.splice(index, 1);
    setAreas(tempAreas);
  };

  return (
    <Box title={`Daerah Terdampak Trouble Internet`} loading={dataLoading || loading}>
      <AlertBox {...alert} setAlert={setAlert} />
      <form onSubmit={(event) => submitData(event)}>
        <div className="form-group">
          <label>Respon Pesan Gangguan</label>
          <textarea
            className="form-control"
            rows={3}
            required
            value={info.disruption_message}
            onChange={(event) => changeInfoValue("disruption_message", event.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Respon Pesan Jika Daerah Tidak Ditemukan</label>
          <textarea
            className="form-control"
            rows={3}
            required
            value={info.not_found_message}
            onChange={(event) => changeInfoValue("not_found_message", event.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Respon Pesan Jika Tidak Ada Gangguan</label>
          <textarea
            className="form-control"
            rows={3}
            required
            value={info.no_disruption_message}
            onChange={(event) => changeInfoValue("no_disruption_message", event.target.value)}
          />
        </div>
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th style={{ width: "50%" }}>Daerah</th>
              <th>On/Off</th>
              <th style={{ width: "10%" }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {areas.map((area, index) => (
              <tr key={area.name}>
                <td>{area.name}</td>
                <td>
                  <Toggle
                    checked={area.status === "on"}
                    onChange={(event) => changeAreaStatus(index, event.target.checked)}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteArea(index)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="form-group">
          <label>Tambah Daerah</label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Nama daerah"
              value={newArea}
              onChange={(event) => setNewArea(event.target.value)}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-outline-primary" onClick={addArea}>
                <i className="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        {hasAccess("update-setting") && (
          <div className="d-flex justify-content-end">
            <button className="btn btn-primary">Simpan Perubahan</button>
          </div>
        )}
      </form>
    </Box>
  );
}
